import React from 'react';
import { Card, CardTitle, CardBody, Button } from 'reactstrap';
import { useForm } from 'react-hook-form';
import XMTable from '../../../components/XMTable';

const Webservice = () => {
  const { register, handleSubmit } = useForm();
  const onSubmit = (form) => {
    // TODO: not yet implemented — this Settings form's Save is currently a no-op.
    console.log('### form ###', form);
  };
  return (
    <Card>
      <CardBody>
        <CardTitle>Resources</CardTitle>
        <form onSubmit={handleSubmit(onSubmit)} className="form-horizontal">
          <XMTable
            headers={[{ name: 'Resource' }, { name: 'Resource Type' }, { name: 'Resource Id' }, { name: 'Description' }]}
          >
            <tr>
              <td className="align-middle">Local Menu</td>
              <td className="align-middle">Product Status</td>
              <td className="align-middle">
                <input {...register('productStatus')} type="text" className="form-control" />
              </td>
              <td className="align-middle">Product states used to filter product data.</td>
            </tr>
            <tr>
              <td className="align-middle">Local Menu</td>
              <td className="align-middle">Due Date Item Type</td>
              <td className="align-middle">
                <input {...register('dueDateItemType')} type="text" className="form-control" />
              </td>
              <td className="align-middle">Transaction types used to fiulter transaction data.</td>
            </tr>
            <tr>
              <td className="align-middle">Sage Exchange</td>
              <td className="align-middle">Transaction types</td>
              <td className="align-middle">
                <input {...register('dueDateItemType')} type="text" className="form-control" />
              </td>
              <td className="align-middle">Sage Exchange Transaction types used to classify Sage Exchange Transactions.</td>
            </tr>
            <tr>
              <td className="align-middle">Sage Exchange</td>
              <td className="align-middle">Payment Processor Status</td>
              <td className="align-middle">
                <input {...register('dueDateItemType')} type="text" className="form-control" />
              </td>
              <td className="align-middle">Sage Gateway Type Codes to classify Sage Exchange Gateways used</td>
            </tr>
            <tr>
              <td className="align-middle">Sage Exchange</td>
              <td className="align-middle">Payment Card Status</td>
              <td className="align-middle">
                <input {...register('dueDateItemType')} type="text" className="form-control" />
              </td>
              <td className="align-middle">Sage Excahnge Payment transaction status code used to classify payment transactions</td>
            </tr>
            <tr>
              <td className="align-middle">Miscellaneous</td>
              <td className="align-middle">Customer Statistical Group 1</td>
              <td className="align-middle">
                <input {...register('dueDateItemType')} type="text" className="form-control" />
              </td>
              <td className="align-middle">Sage Exchange Payment transaction stauts codes used to classufy payment transactions</td>
            </tr>
          </XMTable>
          <div className="float-end">
            <Button type="submit" color="primary" outline className="me-3">
              Populate Resources
            </Button>
            <Button type="submit" color="primary">
              Save
            </Button>
          </div>
        </form>
      </CardBody>
    </Card>
  );
};

export default Webservice;
